import React from 'react';
import { Box, AppBar, Toolbar, Typography, Button, Icon } from '@mui/material';
import { Link } from 'react-router-dom';

import './UnauthNav.scss';
const UnauthNav = () => {

  return (
    <Box className="unnav">
      <AppBar position="static" className="unnav-nav">
        
        <Toolbar className="unnav-nav-tb">
          <Link to="/">
            <img src="/images/txTicketDrLogo.png" className="unnav-nav-tb-a-icn" />
          </Link>
          <Button color="inherit" component={Link} to="/login">Login</Button>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
export default UnauthNav;